module.exports = __webpack_public_path__ + "img/zel.8d710176.svg";